export default __webpack_public_path__ + "static/media/primary.f350c12552ff465b2c1b1bd5caa89f3b.svg";